// TransportV2Page - Page-Root.
// Rendert Provider + IconSprite + eigener Page-Header (Titel, Verbunden,
// EN/DE-Button) + Stepper + Scene-Router. Nutzt die globale App-Sidebar,
// die von App.jsx um herum gerendert wird.

import React, { useEffect } from "react";
import { TransportV2Provider, useTransportV2, landschaftsSchrittNoetig } from "./context/TransportV2Context";
import IconSprite from "./components/IconSprite";
import Stepper from "./components/Stepper";
import Scene0Space from "./scenes/Scene0Space";
import Scene1Landscape from "./scenes/Scene1Landscape";
import Scene2Package from "./scenes/Scene2Package";
import Scene3Artifacts from "./scenes/Scene3Artifacts";
import Scene4Config from "./scenes/Scene4Config";
import Scene5Review from "./scenes/Scene5Review";
import PackageNavigator from "./components/PackageNavigator";
import PackagePrechecks from "./components/PackagePrechecks";
import { useLang } from "./i18n";
import { useStageTargetsSync, StageTargetsReadContext } from "./hooks/useStageTargetsSync";
import "./styles/transport-v2.css";

function SceneRouter({ user }) {
  const { state } = useTransportV2();
  switch (state.step) {
    case 0: return <Scene0Space />;
    case 1: return <Scene1Landscape key={user?.id || "anonymous"} userId={user?.id} />;
    case 2: return <Scene2Package key={`${user?.id || "anonymous"}:${state.spaceId}:${state.sourceInstanceId}`} userId={user?.id} />;
    case 3: return <Scene3Artifacts />;
    case 4: return <Scene4Config />;
    case 5: return <Scene5Review user={user} />;
    default: return <Scene0Space />;
  }
}

function StepperGate({ onJump }) {
  const { state, dispatch } = useTransportV2();
  return (
    <Stepper
      active={state.step}
      skip={landschaftsSchrittNoetig(state) ? [] : [1]}
      onJump={state.batch || state.batchRequest ? undefined : (i) => {
        if (i < state.step) dispatch({ type: "SET_STEP", payload: i });
      }}
    />
  );
}

function InnerV2({ user }) {
  const { state } = useTransportV2();
  const { t } = useLang();
  const targetsRead = useStageTargetsSync();
  // Titel + Sub im Browser-Tab nicht aendern - die App tut das schon.
  useEffect(() => { /* no-op */ }, [state.step]);
  // Kein "Verbunden"-Status und kein EN/DE-Knopf mehr im Seitenkopf: die Sprache
  // wird in den Benutzereinstellungen umgeschaltet (iio-lang-change koppelt beide
  // Richtungen), und der Verbindungspunkt trug keine belastbare Information.
  return (
    <div className="v2main">
      <PackagePrechecks />
      <header className="hdr">
        <div>
          <h1>{t("hdr.title")}</h1>
          <div className="sub">{t("hdr.sub")}</div>
        </div>
      </header>
      <StepperGate />
      <div className="content">
        {state.step >= 3 && <PackageNavigator />}
        <StageTargetsReadContext.Provider value={targetsRead}><SceneRouter key={state.step >= 3 ? `${state.pkgId || "none"}:${state.packageEpoch}` : "selection"} user={user} /></StageTargetsReadContext.Provider>
      </div>
    </div>
  );
}

export default function TransportV2Page({ spaces, user }) {
  // spaces-Prop wird durchgereicht, da die anderen Pages es so bekommen. V2
  // laed sich seine Instanzen selbst via loadAllInstances - Konsistenz-Grund
  // (spaces enthaelt keine Instanzen).
  void spaces;
  return (
    <div className="iio iio-transport-v2">
      <IconSprite />
      <TransportV2Provider key={user?.id || "anonymous"} user={user}>
        <InnerV2 user={user} />
      </TransportV2Provider>
    </div>
  );
}
